import { generatePath } from 'react-router-dom';
import { createDatasetSlice } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_WHITELIST,
  SOLUTIONS_STORE_FILES_WHITELIST,
  SOLUTIONS_STORE,
} from '../constants';
import { mapSolutionFilesWhitelistData } from './utils';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_WHITELIST, { solutionId }),
  }).then(mapSolutionFilesWhitelistData);

const solutionFilesWhitelistSlice = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_FILES_WHITELIST,
});

export default solutionFilesWhitelistSlice;
